import React from 'react';
import { useParams } from 'react-router-dom';
import GlobalCollegeView from './GlobalCollegeView';

const GlobalCollegeViewWrapper = () => {
  const { id } = useParams();
  return <GlobalCollegeView globalCollegeId={id} />;
};

export default GlobalCollegeViewWrapper;